import { combineReducers } from 'redux'
import confirmDialog from './ui/confirmDialog.reducer'
import themeSetting from './ui/themeSetting.reducer'
import globalMenu from './ui/globalMenu.reducer'
import errorDialog from './ui/errorDialog.reducer'
import reloadDialog from './ui/reloadDialog.reducer'
import appStateReducer from './ui/appState.reducer'
import helpDocument from './ui/helpDocument.reducer'

export default combineReducers({
    confirmDialog,
    themeSetting,
    globalMenu,
    errorDialog,
    reloadDialog,
    appState: appStateReducer,
    helpDocument,
})
